import React from 'react'
import banner from '../../images/banner.jpg'
import Category from './Category'
import Topproducts from './Topproducts'

export default function Home() {
  return (
    <>
    <div className="herobox">
        <img src={banner} className="herobox img-fluid" alt="hero-banner"/>

        <div className="herobox-content">
            <h1>YOUTUBE VIDEO</h1>
            <button className="readmre-btn"> Shop Now</button>
        </div>

       
    </div>
    <div className="category-flex">
     <Category/>
     <Category/>
     <Category/>
     </div>

     <Topproducts/>



     </>
  )
}
